import { DateUtils } from '@ocean/utils'
import { ListItemLayout, ListItemSegment } from 'layouts/lists'
import { ListItemTitle, ListItemInfo } from 'components/lists/common'
import { ListItemCommonProps } from 'components/lists/types'
import { Root, TitleWrapper } from './ActivityLogListItem.styled'

export type ActivityLogListItemProps = ListItemCommonProps & {
  time?: number
  title?: string
  groupName?: string
}

const ActivityLogListItem: React.FC<ActivityLogListItemProps> = ({
  time,
  onClick,
  header,
  title,
  footer,
}) => {
  function handleClick() {
    onClick && onClick()
  }

  return (
    <Root onClick={handleClick} data-test='ActivityLogListItem'>
      <ListItemLayout>
        <ListItemSegment segmentId='header'>
          <ListItemInfo info={header} dataTest='ActivityLogListItemHeader' />
        </ListItemSegment>
        <ListItemSegment segmentId='content'>
          <TitleWrapper>
            <ListItemTitle title={title} dataTest='ActivityLogListItemContent' />
          </TitleWrapper>
        </ListItemSegment>
        <ListItemSegment segmentId='sidebar'>
          <ListItemInfo
            info={DateUtils.formatShortTime(time)}
            dataTest='ActivityLogListItemSidebar'
          />
        </ListItemSegment>
        <ListItemSegment segmentId='footer'>
          <ListItemInfo info={footer} dataTest='ActivityLogListItemFooter' />
        </ListItemSegment>
      </ListItemLayout>
    </Root>
  )
}

export default ActivityLogListItem
